/**
 * 开发环境
 */
export const dev = () => {
  return process.env.RUNTIME_ENV == 'dev'
}

/**
 * 生产环境
 */
export const prod = () => {
  return process.env.RUNTIME_ENV == 'prod'
}

/**
 * 测试环境
 */
export const test = () => {
  return process.env.RUNTIME_ENV == 'test'
}

/**
 * 获取当前开发环境
 */
export const env = () => {
  return process.env.RUNTIME_ENV
}

export const envConfig = () => {
  let envConfig = process.env.envConfig
  return envConfig
}

export const remBase = () => {
  return 37.5
}



// WEBPACK FOOTER //
// ./src/const/env.js